var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('dv-decoration-8',{staticClass:"header-left-decoration",attrs:{"reverse":true}}),_c('dv-decoration-5',{staticClass:"header-center-decoration"}),_c('dv-decoration-8',{staticClass:"header-right-decoration"}),_c('div',{staticClass:"center-title",on:{"click":_vm.test}},[_vm._v("天泽大宗商品数字化产业平台数据中心")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }